// 社員グループ一覧画面
import React, { useEffect, useCallback, useState } from 'react';
import './List.css';
import '../App.css';
import {
  useMediaQuery,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Snackbar
} from '@material-ui/core';
import {
  makeStyles,
  withStyles,
  createStyles,
  Theme
} from '@material-ui/core/styles';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import FooterComponent from '../components/FooterComponent';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import { useHistory, Redirect } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import {
  mainBlueColor,
  btnColor,
  isLoggedIn,
  employeeGroupRecoilData
} from '../GlobalState';
import LoadingComponet from '../components/LoadingComponent';
import { getEmployeeGroupList } from '../apicalls/employeeGroup';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
      '&:hover': {
        backgroundColor: '#CFCFCF'
      }
    }
  }
}))(TableRow);

function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant='filled' {...props} />;
}

export const EmployeeGroupList: React.FC = () => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);
  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );

  const [employeeGroupApiData, setEmployeeGroupApiData] = useRecoilState(
    employeeGroupRecoilData
  );
  const changeEmployeeGroupApiData = useCallback(
    (newData: any) => setEmployeeGroupApiData(newData),
    [setEmployeeGroupApiData]
  );

  const [apiData, setApiData] = useState<any>(
    employeeGroupApiData !== null ? employeeGroupApiData : []
  );
  const [loading, setLoading] = useState(
    employeeGroupApiData !== null ? false : true
  );
  const [name, setName] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [open, setOpen] = useState(false);

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      formControl: {
        minWidth: 120,
        backgroundColor: '#FFFFFF'
      },
      container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 15
      },
      formControl1: {
        minWidth: 120,
        height: 30,
        borderRadius: 5,
        borderWidth: 1,
        paddingLeft: 5
      },
      main: {
        minWidth: 700
      },
      table: {
        backgroundColor: `${mainColor} !important`,
        color: '#FFFFFF',
        fontWeight: 'bold',
        fontSize: 16
      },
      input: {
        borderColor: '#CCCCCC',
        padding: 5,
        margin: 10
      },
      table1: {}
    })
  );

  const getListOfEmployeeGroupList = () => {
    getEmployeeGroupList(name.trim()).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            changeEmployeeGroupApiData(data.data);
            setApiData(data.data);
            setLoading(false);
          }
        }
      }
    });
  };

  useEffect(() => {
    getListOfEmployeeGroupList();
  }, [name]);

  const matches2 = useMediaQuery('(min-width:900px)');
  const classes = useStyles();
  const history = useHistory();

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  return (
    <div style={{ backgroundColor: '#F5F5F5' }}>
      <AppBarComponent patternName='employee_groups' />
      {loading ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponet />
        </>
      ) : (
        <div
          style={{
            backgroundColor: '#F5F5F5',
            padding: 15,
            minHeight: window.innerHeight - 150
          }}
        >
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>

          <div className={matches2 ? 'main-container-customer' : ''}>
            <div
              className={
                matches2
                  ? 'top-Container-customer'
                  : 'top-Container-customer-responsive'
              }
              style={{ gap: 10, paddingLeft: 0 }}
            >
              <input
                style={{ backgroundColor: '#FFFFFF' }}
                className={classes.formControl1}
                placeholder='社員グループ名'
                maxLength={30}
                onChange={text => {
                  setName(text.target.value);
                }}
              />
              <Button
                style={{
                  marginLeft: matches2 ? 20 : 0,
                  backgroundColor: buttonColor
                }}
                variant='contained'
                color='primary'
                onClick={getListOfEmployeeGroupList}
              >
                検索
              </Button>
            </div>
          </div>

          <div
            style={{ padding: 15, backgroundColor: '#FFFFFF', borderRadius: 5 }}
          >
            <div className='table-top-container-customer'>
              <div style={{ fontWeight: 'bold' }}>社員グループ一覧</div>
              <div>
                <Button
                  style={{
                    backgroundColor: buttonColor,
                    marginRight: 10,
                    marginBottom: !matches2 ? 10 : 0
                  }}
                  variant='contained'
                  color='secondary'
                  startIcon={<NoteAddIcon />}
                  onClick={() => history.push('/employee-groups/create')}
                >
                  新規作成
                </Button>
              </div>
            </div>

            <TableContainer component={Paper}>
              <Table className={classes.main} aria-label='customized table'>
                <TableHead>
                  <TableRow>
                    <StyledTableCell className={classes.table} align='left'>
                      社員グループ名
                    </StyledTableCell>
                    {
                      // <StyledTableCell className={classes.table} align="left">
                      //   メールアドレス
                      // </StyledTableCell>
                      // <StyledTableCell className={classes.table} align="left">
                      //   利用機能
                      // </StyledTableCell>
                    }
                    {/* <StyledTableCell
                      className={classes.table}
                      align="left"
                    ></StyledTableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {apiData.map((row: any) => (
                    <StyledTableRow
                      key={row.name}
                      className='click_table_row'
                      title='編集'
                      onClick={() =>
                        history.push(`/employee-groups/${row.id}/edit`, {
                          state: row.id
                        })
                      }
                    >
                      <StyledTableCell
                        className={classes.table1}
                        style={{ minWidth: 100 }}
                        align='left'
                      >
                        {row.name}
                      </StyledTableCell>
                      {
                        // <StyledTableCell
                        //   className={classes.table1}
                        //   style={{ minWidth: 90 }}
                        //   align="left"
                        // >
                        //   {row.email}
                        // </StyledTableCell>
                        // <StyledTableCell
                        //   className={classes.table1}
                        //   style={{ minWidth: 100 }}
                        //   align="left"
                        // >
                        //   {row.roles}
                        // </StyledTableCell>
                      }
                      {/* <StyledTableCell className={classes.table1} align="left">
                        <Button
                          style={{ backgroundColor: buttonColor }}
                          variant="contained"
                          color="primary"
                          onClick={() =>
                            history.push(`/employee-groups/${row.id}/edit`, {
                              state: row.id,
                            })
                          }
                        >
                          編集
                        </Button>
                      </StyledTableCell> */}
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
              {!loading && apiData.length === 0 && (
                <div className={classes.container}>データがありません</div>
              )}
            </TableContainer>
          </div>
        </div>
      )}
      <FooterComponent />
    </div>
  );
};
